import { Link } from "react-router-dom";

//assets
import logo from "assets/svg/fullLogo.svg";
import lineBg from "assets/svg/lineBg2.svg";
import { Modal } from "antd";

export default function AuthPageWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const lineBgStyle = {
    background: `url(${lineBg}) no-repeat bottom`,
    backgroundColor: "#ffffff",
  };

  return (
    <section className="w-full flex justify-center h-[100vh] overflow-hidden bg-orange10 font-grotesk px-[16px]">
      {/* form */}
      <section
        style={lineBgStyle}
        className="w-full px-[16px] lg:px-[50px] py-[57px] lg:pt-[57px] pb-[110px] max-w-[546px] h-fit lg:h-[577px] rounded-[32px] flex flex-col bg-white  mt-[59px] border-[5.5px] border-text-color-50"
      >
        <div className=" ">
          <Link to="/">
            <div className="mb-10">
              <img src={logo} alt="Stagepanda Logo" className="lg:w-24" />
            </div>
          </Link>

          {/* Main content */}
          {children}
        </div>
      </section>
    </section>
  );
}

export function AuthPageWrapperModal({
  children,
  open,
  handleClose,
}: {
  children: React.ReactNode;
  open: boolean;
  handleClose: () => void;
}) {
  const lineBgStyle = {
    background: `url(${lineBg}) no-repeat bottom`,
    backgroundColor: "#ffffff",
  };
  return (
    <Modal
      open={open}
      onCancel={() => handleClose()}
      footer={null}
      width={"fit-content"}
      centered
      destroyOnClose={true}
      closable={false}
      styles={{
        body: {
          padding: 0,
          borderRadius: "32px",
        },
        content: {
          padding: 0,
          borderRadius: "32px",
        },
      }}
    >
      <section
        style={lineBgStyle}
        className="w-full sm:min-w-[350px] md:min-w-[400px] lg:min-w-[546px] px-[16px] lg:px-[50px] py-[57px] lg:pt-[57px] pb-[110px] max-w-[546px] h-fit lg:h-[577px] rounded-[32px] flex flex-col bg-white mt-[59px] border-[5.5px] border-text-color-50"
      >
        <div className="w-full">
          <Link to="/">
            <div className="mb-10">
              <img src={logo} alt="Stagepanda Logo" className="lg:w-24" />
            </div>
          </Link>

          {/* Main content */}
          {children}
        </div>
      </section>
    </Modal>
  );
}
